import { Component, Input } from '@angular/core';
import { AboutGroups, GroupItem } from '../model/about-group';
import { CommonModule } from '@angular/common';
import { BadgeModule } from 'primeng/badge';
import { Router } from '@angular/router';
import { VersionService } from '../children/version/version.service';

@Component({
  selector: 'app-about-section',
  standalone: true,
  imports: [
    CommonModule,
    BadgeModule
  ],
  templateUrl: './about-section.component.html',
  styleUrl: './about-section.component.scss'
})
export class AboutSectionComponent {

  readonly STORAGE_KEYS = {
    about: 'about.prevSelectedPeriod',
  };
  @Input() dataGroups: AboutGroups = {
    title: "",
    aboutMenuGroups: [],
  };
  versionBadgeValue: string = "0";
  faqQuestionPaths: string[] = ['general', 'flights', 'analyze', 'search', 'admin']

  constructor(
    private versionService: VersionService,
    private router: Router
  ) {
    this.versionBadgeValue = this.versionService.getAboutBadgeValue();
  }

  onCellPress(path: GroupItem["path"]) {
    if (path === "version") {
      sessionStorage.setItem('to', JSON.stringify('version'));
      this.router.navigate(["about/version"]);
    }
    else if (path === "feedback") {
      sessionStorage.setItem('to', JSON.stringify('feedback'));
      this.router.navigate(["about/feedback"]);
    }
    else if (this.faqQuestionPaths.includes(path)) {
      sessionStorage.setItem('to', JSON.stringify('faq'));
      this.router.navigate(["/about/faq", path]);
    }
    else if (path === "disclaimer") {
      sessionStorage.setItem('to', JSON.stringify('disclaimer'));
      this.router.navigate(["about/disclaimer"]);
    }
  }

  
}
